import { LinearProgress } from "@mui/material";

import { useAvailabilityListPass } from "../../apiHooks";
import { WarningMessage } from "../../components";
import { useNextTranslation } from "../../hooks";

type AvailabilityPassProps = {
    productId: string;
    onAvailabilityUpdated: (availabilityListItemId?: string) => void;
};
export const AvailabilityPass = ({ productId, onAvailabilityUpdated }: AvailabilityPassProps) => {
    const [t] = useNextTranslation("availability");
    const soldOutMessage = t("message.soldOut");
    const notDateSelectionRequiredMessage = t("message.notDateSelectionRequired");

    const availabilityPassQuery = useAvailabilityListPass(productId, {
        onCompleted: (data) => {
            const hasAvailability = data.availabilityList.nodes.length > 0;
            const availabilityListItemId = hasAvailability ? data.availabilityList.nodes[0].id : undefined;
            onAvailabilityUpdated(availabilityListItemId);
        },
        fetchPolicy: "no-cache",
    });

    if (availabilityPassQuery.error) {
        throw availabilityPassQuery.error;
    }

    const isLoading = availabilityPassQuery.loading;
    const hasAvailability = (availabilityPassQuery.data?.availabilityList.total ?? 0) > 0;

    if (isLoading) {
        return <LinearProgress />;
    }

    const warning = hasAvailability ? notDateSelectionRequiredMessage : soldOutMessage;

    return <WarningMessage align="left" warning={warning} />;
};
